import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5402584a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = { class: "px-6 py-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Usuários", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_6 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_8 = {
  id: "example",
  class: "stripe hover",
  style: {"width":"100%","padding-top":"1em","padding-bottom":"1em"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", { class: "hidden" }, "Lista de usuários", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "1",
      scope: "row"
    }, "Nome"),
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "2",
      scope: "row"
    }, "Perfil"),
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "2",
      scope: "row"
    }, "E-mail"),
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "2",
      scope: "row"
    }, "Celular"),
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "3",
      scope: "row"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      "data-priority": "3",
      scope: "row"
    }, " ")
  ])
], -1))
const _hoisted_11 = { class: "flex gap-5" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "shadow overflow-hidden flex border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-48"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("embed", {
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex w-full mt-4" }
const _hoisted_18 = {
  key: 2,
  id: "overlay",
  class: "fade-in"
}
const _hoisted_19 = { class: "w-4/5 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = {
  key: 0,
  class: "mt-5 grid md:flex gap-5"
}
const _hoisted_22 = { class: "w-5/12 mr-5" }
const _hoisted_23 = { class: "w-7/12 mr-5" }
const _hoisted_24 = {
  key: 0,
  class: "col-span-10 flex w-full items-center gap-4 mt-5"
}
const _hoisted_25 = { class: "mt-5 grid md:flex gap-5" }
const _hoisted_26 = { class: "mt-5 grid md:flex" }
const _hoisted_27 = {
  key: 0,
  class: "flex gap-5 w-10/12"
}
const _hoisted_28 = { class: "w-2/12" }
const _hoisted_29 = {
  key: 2,
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}
const _hoisted_30 = {
  key: 3,
  id: "overlay",
  class: "fade-in"
}
const _hoisted_31 = { class: "w-2/5 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Excluir usuário ", -1))
const _hoisted_33 = { class: "col-span-1 mb-5 message-box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-auto mr-2" }, "Tem certeza que deseja excluir este usuário?", -1))
const _hoisted_35 = { class: "col-span-10 flex h-full w-full items-center justify-end gap-4 mt-5" }
const _hoisted_36 = {
  key: 2,
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_ProfileUploader = _resolveComponent("ProfileUploader")!
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.usuarios.length !== 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usuarios, (usuario) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: usuario.userId
                        }, [
                          _createElementVNode("td", null, _toDisplayString(usuario.name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.types.filter((type) => (usuario.userType && type.value === usuario.userType) || (type.value === usuario.userType))[0].label), 1),
                          _createElementVNode("td", null, _toDisplayString(usuario.email), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.applyMask('Celular', usuario.telefone)), 1),
                          _createElementVNode("td", null, _toDisplayString(usuario.active ? 'Ativo' : 'Inativo'), 1),
                          _createElementVNode("td", _hoisted_11, [
                            (usuario.active)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.update(usuario))
                                }, [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    class: "text-yellow-300 cursor-pointer",
                                    icon: _ctx.pen
                                  }, null, 8, ["icon"])
                                ], 8, _hoisted_12))
                              : _createCommentVNode("", true),
                            (usuario.email !== this.$store.state.user.email)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.disable(usuario))
                                }, [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    class: "text-red-500 cursor-pointer",
                                    icon: _ctx.trash
                                  }, null, 8, ["icon"])
                                ], 8, _hoisted_13))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PrimaryButton, {
          class: "ml-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.form = true; _ctx.updating = false; _ctx.user = {}; _ctx.profile.image = null}),
          label: "Novo"
        })
      ]),
      (_ctx.form)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "h-screen flex overflow-y-scroll p-8",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.closeModal()), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h1", _hoisted_20, _toDisplayString(!_ctx.updating ? 'Cadastrar Novo ' : 'Editar ') + " usuário", 1),
                (_ctx.updating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ProfileUploader, {
                          image: _ctx.profile.image,
                          labelPlaceholder: "Imagem de perfil",
                          types: _ctx.profile.types,
                          onUploaded: _ctx.handleUploadedImage
                        }, null, 8, ["image", "types", "onUploaded"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Cropper, {
                          ref: "cropper",
                          src: _ctx.cropperComponent.image,
                          class: "w-35",
                          autoZoom: "",
                          stencilProps: {
                    aspectRatio: 1/1,
                    handlersClasses: {
                      default:
                        '!rounded-[0.65rem] !border !border-gray-400 !bg-white !scale-110 !transition-colors',
                      hover: '!bg-gray-300',
                    },
                    linesClasses: {
                      default: '!border-gray-400 !border-1',
                    },
                  },
                          imageClass: "border border-gray-300 dark:border-gray-400",
                          backgroundClass: "!bg-white !opacity-50 dark:!opacity-90",
                          foregroundClass: "!bg-white !opacity-50",
                          imageRestriction: "fit-area",
                          onReady: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hanbleImageCropping(true)))
                        }, null, 8, ["src", "stencilProps"]),
                        (_ctx.cropperComponent.isCropping)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_component_Button, {
                                class: "ml-auto",
                                label: "Cancelar",
                                type: "button",
                                onClick: _ctx.handleCancelCropping
                              }, null, 8, ["onClick"]),
                              (!_ctx.saving)
                                ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                                    key: 0,
                                    label: "Aplicar",
                                    onClick: _ctx.handleImageProfile
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Input, {
                    label: "Nome",
                    labelClass: "p-0",
                    incorrectMessage: _ctx.validations.nomeMessage,
                    isIncorrect: _ctx.validations.nomeMessage != '',
                    modelValue: _ctx.user.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.name) = $event))
                  }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                  (!_ctx.updating)
                    ? (_openBlock(), _createBlock(_component_Input, {
                        key: 0,
                        label: "E-mail",
                        labelClass: "p-0",
                        incorrectMessage: _ctx.validations.emailMessage,
                        isIncorrect: _ctx.validations.emailMessage != '',
                        disabled: _ctx.updating,
                        modelValue: _ctx.user.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.email) = $event))
                      }, null, 8, ["incorrectMessage", "isIncorrect", "disabled", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (!_ctx.updating)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_Input, {
                            label: "Código",
                            labelClass: "p-0",
                            incorrectMessage: _ctx.validations.telefoneMessage,
                            isIncorrect: _ctx.validations.telefoneMessage != '',
                            modelValue: _ctx.code,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.code) = $event)),
                            disabled: true,
                            value: "'+55'"
                          }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                        ]),
                        _createVNode(_component_Input, {
                          class: "w-10/12 mr-5",
                          label: "Celular",
                          labelClass: "p-0",
                          incorrectMessage: _ctx.validations.telefoneMessage,
                          isIncorrect: _ctx.validations.telefoneMessage != '',
                          mask: "(##) #####-####",
                          modelValue: _ctx.user.telefone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.telefone) = $event))
                        }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Select, {
                    selected: _ctx.selectedItem,
                    label: "Perfil",
                    options: () => {if (!_ctx.updating ) return _ctx.selectValues.filter(
                  selectValue => {
                      return selectValue.value !== 'Root'
                    })
                      else return _ctx.selectValues
                    },
                    display: "value",
                    itemId: "value",
                    event: "update:editValue",
                    "onUpdate:editValue": _ctx.changeType,
                    incorrectMessage: _ctx.validations.tipoMessage,
                    isIncorrect: _ctx.validations.tipoMessage != ''
                  }, null, 8, ["selected", "options", "onUpdate:editValue", "incorrectMessage", "isIncorrect"])
                ]),
                (!_ctx.saving)
                  ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                      key: 1,
                      class: "ml-auto",
                      onClick: _ctx.save,
                      label: "Salvar"
                    }, null, 8, ["onClick"]))
                  : (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("embed", _hoisted_29))
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.confirmModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", {
              class: "h-screen flex overflow-y-scroll p-8",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.confirmModal=false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_FontAwesomeIcon, {
                    icon: _ctx.exclamation,
                    class: "text-white my-auto ml-2 mr-2"
                  }, null, 8, ["icon"]),
                  _hoisted_34
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (!_ctx.saving)
                    ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                        key: 0,
                        class: "-lg:w-full",
                        onClick: _ctx.removeUser,
                        label: "Excluir"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.saving)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        label: "Cancelar",
                        width: "-lg:w-full",
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.confirmModal=false), ["prevent"]))
                      }))
                    : (_ctx.saving)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_36))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}